/******************************************************************************************
 *	Bulk Invite Reseller Controller
 ******************************************************************************************/
 (function() {
    angular.module('rcControllers.licenseAdminBulkInviteResellerController', []).controller(
      'LicenseAdminBulkInviteResellerController',
      /* @ngInject */
      function(
        _,
        $state,
        $translate,
        CsvToArray,
        Resellers,
        Regions,
        CountryList,
        ArrayToCsv,
        CSV_COLUMN_SEPARATOR,
        CSV_ROW_SEPARATOR,
        downloadUtils
      ) {
        var vm = this;

        vm.resellerList = [];
        vm.inviteCompleted = false;
        vm.resellerListToInvite = [];
        vm.invitedResellersList = [];
        vm.resellerInvitationErrorList = [];
        vm.countriesCallFailed = false;
        vm.regionsCallFailed = false;
        vm.loadedCountryCode = null;
        vm.loadedRegions = null;

        /*=== Import reseller list from CSV file ===*/
        vm.fileContent = null;
        vm.importCsvContent = function() {
          // Reset resellerList, so we can repopulate it with CSV content.
          vm.resellerList = [];
          vm.dataError = false;
          vm.dataErrorMessage = '';
          // Parse the CSV content
          var resellerEntries = CsvToArray.convert(vm.fileContent);
          if (!resellerEntries || resellerEntries.length === 0) {
            vm.dataError = true;
            vm.dataErrorMessage = 'licenseAdminBulkInviteReseller.emptyOrNoFileError';
          } else {
            _.forEach(resellerEntries, function(resellerData) {
              if (resellerData[0] === 'Membership ID' || !resellerData[0]) {
                return;
              }
              // We expect the columns to be in the following order:
              // Sales Contract Id, Account Name, Address line 1, City, State/Province, Zip Code, Country/Region, First Name, Last Name, Email, Preferred Language

              if (resellerData.length < 10) {
                // We're missing some data.
                vm.dataError = true;
                vm.dataErrorMessage = 'licenseAdminBulkInviteReseller.missingColumnsError';
              } else {
                var resellerObj = {
                  externalSalesContractId: resellerData[0],
                  name: resellerData[1],
                  address: {
                    street1: resellerData[2],
                    city: resellerData[3],
                    region: {
                      regionName: resellerData[4]
                    },
                    postalCode: resellerData[5],
                    country: {
                      countryCode: resellerData[6]
                    }
                  },
                  primaryAdmin: {
                    first_name: resellerData[7],
                    last_name: resellerData[8],
                    email: resellerData[9],
                  },

                  preferredLanguage: resellerData[10],
              };
                // Add data to our reseller list
                vm.resellerList.push(resellerObj);
              }
            });

            if (vm.resellerList.length > 100) {
              vm.dataError = true;
              vm.dataErrorMessage = 'licenseAdminBulkInviteReseller.exceededFileError';
            }
          }

          // Sort resellerList based on countryCode.
          vm.resellerList.sort(function (current, next) {
            const currentCountryCode =  _.get(current.address.country, 'countryCode', '');
            const nextCountryCode =  _.get(next.address.country, 'countryCode', '');
            if (currentCountryCode < nextCountryCode) {
              return -1;
            }
            if (currentCountryCode > nextCountryCode) {
              return 1;
            }
            return 0;
          });
        };

        vm.chooseNewCsv = function() {
          // Clear the reseller list and the file content, so the File Chooser UI is shown
          vm.resellerList = null;
          vm.fileContent = null;
          vm.dataError = false;
          vm.dataErrorMessage = '';
        };

        var fetchCountries = function() {
          CountryList.get()
            .$promise.then(function(countryList) {
              vm.countries = _.orderBy(countryList.items, ['countryName']);
            })
            .catch(function() {
              vm.countriesCallFailed = true;
            });
        };

        fetchCountries();

        vm.checkRegionAndUpdatePayload = function({resellerListItem, matchingCountry, regionNameOrCode}) {

          const matchingRegion = _.find(vm.loadedRegions, function(region) {
            return region.regionName === regionNameOrCode || region.regionCode === regionNameOrCode;
          });

          _.assign(resellerListItem.address, {
            country: matchingCountry,
            region: _.isEmpty(matchingRegion) ? {} : matchingRegion
          });

          Resellers.invite(resellerListItem)
          .then(function() {
            vm.invitedResellersList.push({
              externalSalesContractId: resellerListItem.externalSalesContractId,
              name: resellerListItem.name,
              email: resellerListItem.primaryAdmin.email
            });
          })
          .catch(function(response) {
            vm.resellerInvitationErrorList.push({
              externalSalesContractId: resellerListItem.externalSalesContractId,
              name: resellerListItem.name,
              email: resellerListItem.primaryAdmin.email,
              requestId: response.headers()['x-request-id'],
              errorCode: response.data['errorCode']
            });
          }).finally(() => {
            if (vm.resellerListToInvite.length === 0) {
              vm.inviteCompleted = true;
            } else {
              const resellerListItem = vm.resellerListToInvite.pop();
              vm.resellersInviteSubmit(resellerListItem);
            }
          });
        };

        vm.resellersInviteSubmit = function(resellerListItem) {
          if (resellerListItem.externalSalesContractId) {
            const countryCode = _.get(resellerListItem.address.country, 'countryCode', '');
            const regionNameOrCode = _.get(resellerListItem.address.region, 'regionName', '');
            const matchingCountry = _.find(vm.countries, {'countryCode': countryCode});
            const countryMisMatch = vm.loadedCountryCode !== countryCode;

            if (_.isEmpty(vm.loadedRegions) || countryMisMatch) {
              Regions.get(countryCode)
                .then(function(responseData) {
                  vm.loadedCountryCode = countryCode;
                  vm.loadedRegions = responseData;
                  vm.checkRegionAndUpdatePayload({resellerListItem, matchingCountry, regionNameOrCode});
                })
                .catch(function() {
                  vm.regionsCallFailed = true;
                });
            } else {
              vm.checkRegionAndUpdatePayload({resellerListItem, matchingCountry, regionNameOrCode});
            }
          }
        };

        vm.inviteResellerList = function() {
          if (vm.resellerList && vm.resellerList.length > 0) {
            vm.submitted = true;
            vm.inviteErrors = false;
            // Create a copy of the reseller list to iterate over
            vm.resellerListToInvite = vm.resellerList.slice();

            const resellerListItem = vm.resellerListToInvite.pop();
            vm.resellersInviteSubmit(resellerListItem);
          }
        };

        vm.exportFailedToInviteReseller = function() {
          var csvContent = '';
          // Row headers
          csvContent +=
            $translate.instant('licenseAdminBulkInviteReseller.resellerContractId') + CSV_COLUMN_SEPARATOR;
          csvContent +=
            $translate.instant('licenseAdminBulkInviteReseller.accountName') + CSV_COLUMN_SEPARATOR;
          csvContent +=
            $translate.instant('licenseAdminBulkInviteReseller.email') + CSV_COLUMN_SEPARATOR;
          csvContent +=
            $translate.instant('licenseAdminBulkInviteReseller.requestId') + CSV_COLUMN_SEPARATOR;
          csvContent +=
            $translate.instant('licenseAdminBulkInviteReseller.errorCode') + CSV_ROW_SEPARATOR;
          // Customer rows
          csvContent += ArrayToCsv.convert(vm.resellerInvitationErrorList);
          //Trigger file download
          downloadUtils.downloadExportData(csvContent, 'failed-to-invite-reseller.csv');
        };

        //Navigation
        vm.goBack = function() {
          $state.go('licenseAdmin.search');
        };
      }
    );
  })();

